module.exports = __webpack_public_path__ + "img/500-bg-left.134f16d.webp";